import * as React from "react";
const SvgGMobiledata = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 11v2h2v2H9V9h7V7H7v10h9v-6h-4z",
  fill: "currentColor"
}));
export default SvgGMobiledata;